import React from "react";
import { useMediaQuery } from "react-responsive";
import { LazyLoadImage } from "react-lazy-load-image-component";

const BusinessPartner = ({ content }) => {
  const isTablet = useMediaQuery({ query: "(max-width: 992px)" });

  const columnsNumber = items => `repeat(${items.length === 2 ? 2 : items.length / 2}, 1fr`;

  return (
    <div id="businessPartner">
      <div className="title" dangerouslySetInnerHTML={{ __html: content.title }} />
      <div className="subtitle" dangerouslySetInnerHTML={{ __html: content.subtitle }} />
      {isTablet && <div className="description" dangerouslySetInnerHTML={{ __html: content.description }} />}
      {isTablet ? (
        <div className="wrapper">
          {[Math.floor((content.list.length + 2) / 3)]
            .map(it => {
              let tmp = [];
              for (let i = 0; i < it; i++) {
                tmp.push(i);
              }
              return tmp;
            })[0]
            ?.map((gr, idxG) => {
              return (
                <div className="imgGroup" key={idxG}>
                  {content.list.slice(gr * 3, gr * 3 + 3).map((image, i) => (
                    <div key={idxG + "_" + i} className="logo">
                      <LazyLoadImage alt="logo" effect="blur" src={image.media?.url} />
                    </div>
                  ))}
                </div>
              );
            })}
        </div>
      ) : (
        <div className="grid" style={{ gridTemplateColumns: columnsNumber(content.list) }}>
          {content.list.map((image, i) => (
            <LazyLoadImage key={i} alt="logo" effect="blur" src={image.media?.url} />
          ))}
        </div>
      )}
    </div>
  );
};

export default BusinessPartner;
